import type { HandleClientError } from '@sveltejs/kit';
import { dev } from '$app/environment';
import { env } from '$env/dynamic/public';
import { initializeSplunkRum, useSplunkRum } from '$lib/services/tracking/splunk/splunkRum';
import { enableBrowserMock } from '$test_utils/mocks/enableBrowserMock';

initializeSplunkRum();

if (dev && env?.PUBLIC_ENABLE_BROWSER_MSW === 'true') {
	enableBrowserMock();
}

export const handleError: HandleClientError = async ({ error, event }) => {
	useSplunkRum((SplunkRum) => {
		const normalizedError = error instanceof Error ? error : new Error(typeof error === 'string' ? error : 'Unknown error');
		const attributes = {
			'vm.event.route.id': event.route?.id ?? '',
			'vm.event.url': event.url?.toString() ?? '',
			'vm.event.params': JSON.stringify(event.params ?? {}),
		};
		SplunkRum.reportError(normalizedError, attributes);
	});
};
